import type { Client, MetaData, Content, UserAttributes } from "./types";
import config from "../../../app.config";
export type { Client };

const { appId: APP_ID } = config.plugins.find(([name]) => name === "@intercom/intercom-react-native")?.[1] as {
  appId: string;
};

// copied from intercom
// @ts-ignore
// prettier-ignore
(function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();

class Intercom implements Client {
  init(attributes?: UserAttributes, hmac?: string) {
    window.Intercom("boot", {
      app_id: APP_ID,
      user_id: attributes?.userId,
      user_hash: hmac,
    });
  }

  logEvent(name: string, metadata: MetaData) {
    window.Intercom("trackEvent", name, metadata);
  }

  present(content?: Content) {
    const { article } = content || {};
    if (article) window.Intercom("showArticle", parseInt(article));
    else {
      window.Intercom("show");
    }
  }

  presentMessageComposer() {
    window.Intercom("showNewMessage");
  }
}

export default new Intercom();
